import { makeStyles } from "@material-ui/core"

import { themeColors } from "letalkui"

const useStyles = makeStyles(theme => ({
	card: {
		backgroundColor: themeColors.colors.system.purple[50],
		border: `1px solid ${themeColors.colors.system.purple[200]}`,
		borderRadius: 8,
		padding: theme.spacing(2)
	},
	iconBox: {
		backgroundColor: themeColors.colors.system.gray[0],
		borderRadius: 8,
		width: 40,
		height: 40,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0
	},
	title: {
		fontWeight: 700
	},
	description: {
		color: themeColors.colors.system.gray[700]
	},
	cta: {
		color: themeColors.getPrimaryColor(),
		fontWeight: 600,
		cursor: "pointer",
		textDecoration: "none"
	}
}))

export default useStyles
